
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.47 30.917L30.734 18.46a12.61 12.61 0 001.072-5.097C31.806 6.374 26.14.708 19.15.708c-6.99 0-12.656 5.667-12.656 12.655 0 1.858.403 3.62 1.121 5.209L.85 30.912a1.152 1.152 0 001.267 1.675l5.778-1.326 1.977 5.508a1.15 1.15 0 002.098.155l5.888-10.97a12.786 12.786 0 002.477.007l6.016 10.971a1.15 1.15 0 002.093-.164l1.978-5.508 5.778 1.326c.443.107.9-.065 1.173-.425a1.15 1.15 0 00.097-1.244zm-26.305 2.64l-1.448-4.035a1.147 1.147 0 00-1.341-.732l-4.274.98 4.871-8.884a12.674 12.674 0 006.527 4.597l-4.335 8.074zM29.94 28.79a1.146 1.146 0 00-1.341.732l-1.458 4.064-4.43-8.078a12.675 12.675 0 006.673-4.702l4.85 8.968-4.294-.984z","fill":"#F79429"}}),_c('path',{attrs:{"d":"M18.815 19.175a4.34 4.34 0 01-1.691-.335 3.928 3.928 0 01-1.357-.948 3.285 3.285 0 01-.758-1.415l1.735-.613c.175.486.443.86.803 1.123.36.263.782.394 1.268.394.584 0 1.05-.165 1.4-.496.36-.33.54-.777.54-1.341 0-.555-.18-.992-.54-1.313-.35-.33-.821-.496-1.414-.496-.409 0-.778.078-1.109.234l-.452-.948 2.815-3.209H15.62V8.135h6.665v1.56l-2.231 2.611c.817.126 1.468.476 1.954 1.05.486.564.73 1.274.73 2.13 0 .69-.17 1.317-.511 1.88a3.58 3.58 0 01-1.415 1.328c-.593.32-1.259.48-1.998.48z","fill":"#000"}})])
          )
        }
      }
    